import {UI, registerStyle, styleRule, StyleSheet} from "../../../../stem-core/src/ui/UI";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";

import {RollAnimatedBalance} from "../../../common/RollAnimatedBalance";
import {AddFundsExpanded, addFundsBalanceStyle} from "./sections/AddFundsExpanded";
import {TopUpPaymentStore, PaymentMethodStore} from "../../../State";
import {POPUP_TRANSITION_TIME} from "../../WidgetConstants";
import {AddFundsMinimised, minimisedBalanceStyle} from "./sections/AddFundsMinimised";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement";
import {isSmallScreen} from "../../../Utils";
import {Device} from "../../../../stem-core/src/base/Device";
import {Router} from "../../../../stem-core/src/ui/Router";


class AddFundsStyle extends StyleSheet {
    transition = POPUP_TRANSITION_TIME + "ms ease";

    @styleRule
    element = {
        background: this.themeProps.WALLET_GRADIENT_BACKGROUND,
        color: this.themeProps.WALLET_COLOR,
        height: 39,
        overflow: "hidden",
        borderRadius: 0,
        bottom: 0,
        transition: this.transition,
    };

    @styleRule
    elementExpanded = {
        height: "100%",
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : "12px 12px 0 0",
        ">:first-child": {
            opacity: 1,
            zIndex: 2,
        },
        ">:nth-child(2)": {
            opacity: 0,
        },
        ">:last-child": {
            ...addFundsBalanceStyle,
            marginBottom: 0,
            width: "100% !important",
            left: 0,
            zIndex: 3,
        },
    };

    @styleRule
    addFunds = {
        visibility: "hidden",
        transition: this.transition,
        position: "absolute",
        top: 0,
        height: "initial !important",
        minHeight: "100%",
    };

    @styleRule
    addFundsMinimised = {
        transition: this.transition,
        opacity: 1,
    };

    @styleRule
    animationBalance = {
        ...minimisedBalanceStyle,
        transition: this.transition,
        position: "absolute !important",
        left: 24,
        bottom: 13,
        zIndex: 0,
    };
}

@registerStyle(AddFundsStyle)
export class AddFunds extends WidgetActiveRouteElement {
    shouldCollapseAddFunds = false;
    expandedAddFunds = false;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.element);
        if (this.expandedAddFunds && this.addFunds && this.addFunds.balance) {
            attr.addClass(this.styleSheet.elementExpanded);
            this.addFunds.setStyle("visibility", "visible");
            this.attachTimeout(() => {
                const addFundsRect = this.addFunds.node.getBoundingClientRect();
                const balanceRect = this.addFunds.balance.node.getBoundingClientRect();
                this.balance.setStyle("bottom", addFundsRect.bottom - balanceRect.bottom);
            });
        }
    }

    render() {
        const {styleSheet} = this;

        return [
            <AddFundsExpanded ref="addFunds" className={styleSheet.addFunds}/>,
            <AddFundsMinimised className={styleSheet.addFundsMinimised}/>,
            <RollAnimatedBalance ref="balance" className={styleSheet.animationBalance} />,
        ];
    }

    static show(options) {
        const {instance} = this;
        instance.expandedAddFunds = true;
        instance.updateOptions(options);
    }

    static hide() {
        const {instance} = this;
        instance.expandedAddFunds = false;
        instance.redraw();
    }

    computeHeight() {
        return this.addFunds.computeHeight();
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(TopUpPaymentStore, transaction => {
            if (transaction && transaction.status === TopUpPaymentStore.Status.SUCCEEDED) {
                Dispatcher.Global.addListenerOnce("balanceAnimationFinished", () => {
                    if (this.shouldCollapseAddFunds && this.expandedAddFunds) {
                        Router.back();
                    }
                    this.shouldCollapseAddFunds = false;
                });
            }
        });

        this.attachListener(Dispatcher.Global, "killAllPopups", () => this.constructor.hide());
        this.attachChangeListener(PaymentMethodStore, () => this.redraw());

        this.attachListener(Dispatcher.Global, "shouldCollapseAddFunds", () => {
            this.shouldCollapseAddFunds = true;
        });
    }
}
